export default {
  paymentHistory: {
    title: "Payment History",
    back: "Back",
    date: "Date",
    time: "Time",
    receiptNo: "Reference No",
    receiptNoMobile: "Ref No",
    paymentType: "Payment Type",
    paymentDescription: "Payment Description",
    paymentDescriptionMobile: "Description",
    totalAmount: "Total",
    totalAmountMobile: "Total (RM)",
    agentName: "Agent Name",
    status: "Status",
    download: "Receipt",
    downloadReceipt: "Download receipt",
    emptyHeader: "No payment history found",
    createReport: "Create Report",
    export: {
      success: {
        title: "Export successful",
        message:
          "Your Payment History will be available for download in Email within 24 hours. ",
      },
    },
    filters: {
      placeholders: {
        keyword: "Search by",
        agentName: "agent",
        agentNameLong: "agent ID or name",
        refNo: "reference no",
        startDate: "Start date",
        endDate: "End date",
        clear: "Clear",
        filter: "Filter",
        status: {
          label: "Status",
          all: "All",
          1: "Successful",
          2: "Unsuccessful",
        },
      },
      empty: {
        header:
          "We couldn't find any payment history that match your refinements.",
        subHeader: "Try changing your criteria or come back again later.",
      },
      sorting: {
        title: "Sort",
        placeholder: "Date",
        desc: "Date (desc)",
        asc: "Date (asc)",
      },
    },
  },
};
